const productsData = [
  {
  product_id: "mini-francis",
  name: "Mini Francis Turbine Generator",
  category: "turbine_system",

  description:
    "The Mini Francis Turbine Generator is designed for small streams and low-scale hydro sites to generate reliable off-grid power. Compact and efficient, the system integrates seamlessly with an Electronic Load Controller (ELC) to provide stable 240V AC output. It is an ideal solution for remote locations, rural electrification and small hydropower installations.",

  image_url: "/images/products/MF.png",

  features: [
    "Compact Francis turbine optimized for small stream applications",
    "Integrated Electronic Load Controller (ELC) for frequency stability",
    "Stable 240V AC power output",
    "Reliable operation in remote or off-grid locations",
    "Low maintenance and robust construction",
    "High efficiency for micro-hydro power generation"
  ],

  applications: [
    "Small Stream Hydropower Generation",
    "Rural Electrification",
    "Off-Grid Power Systems",
    "Remote Homes and Farms"
  ],

  technical_specs:
    "Output Voltage: 240V AC. Power Options: 5 kW, 10 kW, 15 kW. Turbine Type: Francis. Controller: Integrated Electronic Load Controller (ELC). Suitable for micro-hydro installations using small streams or water channels."
},
  {
    product_id: "elc-1",
    name: "Electronic Load Controller",
    category: "turbine_control",
    description:
      "ELC is an indigenously developed, microcomputer-based controller designed to regulate hydro turbines with both high and low inertia. It ensures precise load control, stable plant operation, and reliable unattended performance. Fully digital and self-tuning, the system has no moving or consumable parts, making it virtually maintenance-free.",
    image_url: "/images/products/ELC.png",

    features: [
      "Ultra Fast Response Times",
      "Any Type of Turbine",
      "Smart Architecture for Reduced Noise and Harmonics"
    ],

    applications: [
      "Small Turbine Frequency Control"
    ],

    technical_specs: "For up to 200KW Turbines"
  },
  {
  product_id: "gov",
  name: "Electronic Governor YT-911",
  category: "turbine_control",

  description:
    "The YT-911 is a state-of-the-art digital programmable electronic governor designed for speed, load and water level control of mini hydroelectric turbines. The governor can be configured through software depending on turbine type, actuator capacity and control requirements. Its powerful user interface and standalone architecture ensure reliable and precise turbine control without dependence on external systems.",

  image_url: "/images/products/GOV.png",

  features: [
    "Built-in Auto Synchroniser for rapid grid synchronisation",
    "Suitable for Kaplan, Francis, Turgo and Pelton turbines",
    "Multi-processor architecture with embedded processors",
    "Suitable for both isolated and grid-connected operation",
    "High-speed digital filtering for noise immunity",
    "Extensive safety interlocks and built-in diagnostics",
    "Front panel interface with displays, push buttons and LED indicators"
  ],

  applications: [
    "Hydro Turbine Speed Control",
    "Load Control of Turbine Generator",
    "Water Level Control",
    "Grid Synchronisation of Mini Hydro Plants"
  ],

  technical_specs:
    "Input Voltage: 110V DC ±10% or 24V DC ±10%. Digital Inputs: 16 channels with optical isolation. Digital Outputs: 16 relay outputs. Analog Inputs: 8 channels (4-20 mA). Analog Outputs: 8 channels (±10 mA). Communication: RS-232 / RS-485 / RS-422 with Modbus RTU/ASCII. Operating Temperature: −40°C to 55°C. Dimensions: 483 × 132.5 × 320 mm. Weight: ~7.5 kg."
}
];

export default productsData;